import type { FileExtractLayoutResultDTO } from '@/components/ai/ReferenceLayoutPdf/dto'

export interface PatentLayoutRequestType {
    patent_nos?: string[]
    patent_ids?: string[]
}

export type PatentLayoutResponseType = Record<string, {
    merged_data: FileExtractLayoutResultDTO[]
}>

export interface IPatentLayoutApi {
    getLayoutByPatent: (params: PatentLayoutRequestType) => Promise<PatentLayoutResponseType>
}

export const IPatentLayoutApi = Symbol('IPatentLayoutApi')
